let KDBaseRed = "#E30022";
// #E30022; // cadmium red
// #ff5277; // pinkish
let KDBaseOrange = "#ff4e20";
// #ED872D; // cadmium orange
// #ff8933; // peachy
// #ff4e20; // ochre
let KDBaseYellow = "#FFF600";
// #FFF600 cadmium yellow
// #FFFf00  yellow
let KDBaseRibbon = "#ba55d3"; // mediumorchid
let KDBasePink = "#ff66cc"; // rose pink
// ##ffb3de; // light hotpink
// #e25098; // raspaberry
// #ff66cc // rose pink
// #cc2f7b; // slime pink
// #ff8888 // Bondage Club pink
let KDBaseLime = "#c1f9a2"; // menthol
// #39ff14; // neon green
// #00ff00 // lime
let KDBaseYellowGreen = "#e3f988"
// #e3f988 // mindaro
// #e8f48c // key lime
// #b2ec5d // inchworm
// # #c1f9a2; // menthol
let KDBasePurple = "#5946b2"; // plum
// #8800ff; // original purple
// #360ccc // interdimensional blue
// #5218fa // plum purple
// #5946b2 // han purple
let KDBaseGreal = "#00ff88";
let KDBaseGreen = "#00b548ff";
// #00ff88 // greenish teal
let KDBaseNeon = "#5cff67"; // lemon lime
// #55ff55
let KDBaseMint = "#98ff98"; // mint green
// #88ff88
let KDBaseLightGreen = "#88FFAA";
// #88ff88
let KDBaseForest = "#228b22";
// #448844
let KDBaseElectricBlue = "#7df9ff";
let KDBaseCyan = "#15f2fd"; // lotion blue
// #7df9ff; // electric blue
// #00ffff // cyan
let KDBaseTeal = "#0a7e8c"; // metallic seaweed
let KDBaseLightBlue = "#6495ed"; // cornflowerblue
let KDBaseBlue = "#0247fe"; // blue
// #0000ff; // navy
// #1c1cf0 // bluebonnet
// #273be2 // palatinate blue
// #0247fe // blue
let KDBaseBaby = "#0088ff";
let KDBaseWhite = "#fffafa" // snow
// #fffafa snow
let KDBaseBlack = "#010203"; // rich black
// #000000
let KDBaseLightGrey = "#80949a";

let KDColorList = {
    KDBaseLightGrey: KDBaseLightGrey,
    KDBaseBlack: KDBaseBlack,
    KDBaseWhite: KDBaseWhite,
    KDBaseBaby: KDBaseBaby,
    KDBaseBlue: KDBaseBlue,
    KDBaseLightBlue: KDBaseLightBlue,
    KDBaseTeal: KDBaseTeal,
    KDBaseCyan: KDBaseCyan,
    KDBaseElectricBlue: KDBaseElectricBlue,
    KDBaseForest: KDBaseForest,
    KDBaseLightGreen: KDBaseLightGreen,
    KDBaseMint: KDBaseMint,
    KDBaseNeon: KDBaseNeon,
    KDBaseGreal: KDBaseGreal,
    KDBasePurple: KDBasePurple,
    KDBaseYellowGreen: KDBaseYellowGreen,
    KDBaseLime: KDBaseLime,
    KDBasePink: KDBasePink,
    KDBaseRibbon: KDBaseRibbon,
    KDBaseYellow: KDBaseYellow,
    KDBaseOrange: KDBaseOrange,
    KDBaseRed: KDBaseRed,
    KDBaseGreen: KDBaseGreen,
};